import React from "react";
import Sidebar from "../components/Sidebar"; // Import the Sidebar component
import { Outlet } from "react-router-dom";

const DoctorDashboard = () => {
  // Sidebar items
  const items = [
    { name: "Dashboard", link: "/doctor", icon: "🏠" },
    { name: "Image Management", link: "/doctor/image-management", icon: "👤" },
    
  ];

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar items={items} />
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <h1>Doctor Dashboard</h1>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    </div>
  );
};

export default DoctorDashboard;
